import { render, staticRenderFns } from "./V2SegmentationSection.vue?vue&type=template&id=5ec5c68a&scoped=true&"
import script from "./V2SegmentationSection.vue?vue&type=script&lang=js&"
export * from "./V2SegmentationSection.vue?vue&type=script&lang=js&"
import style0 from "./V2SegmentationSection.vue?vue&type=style&index=0&id=5ec5c68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec5c68a",
  null
  
)

export default component.exports